function getEnv(name) {
  // @ts-ignore
  return (window?.configs || process.env)[name]
}

export default getEnv('VUE_APP_ENV')
export const PORTAL_API_URL = getEnv('VUE_APP_PORTAL_API_URL')
export const AUTH_API_URL = getEnv('VUE_APP_AUTH_API_URL')
export const AUTH_PROVIDER_URL = getEnv('VUE_APP_AUTH_PROVIDER_URL')
export const NAVER_MAP_CLIENT_ID = getEnv('VUE_APP_NAVER_MAP_CLIENT_ID')
export const FIREBASE_API_KEY = getEnv('VUE_APP_FIREBASE_API_KEY')
export const FIREBASE_MESSAGING_SENDER_ID = getEnv('VUE_APP_FIREBASE_MESSAGING_SENDER_ID')
export const FIREBASE_VAPID = getEnv('VUE_APP_FIREBASE_VAPID')
export const FIREBASE_PROJECT_ID = getEnv('VUE_APP_FIREBASE_PROJECT_ID')
export const FIREBASE_APP_ID = getEnv('VUE_APP_FIREBASE_APP_ID')
export const REPORT_SERVER_URL = getEnv('VUE_APP_REPORT_SERVER_URL')
